import { customersColumns } from "@/components/customers/CustomersColumns";
import { CustomerWithContacts } from "@/database/schema";
import { ColumnDef } from "@tanstack/react-table";
import { CustomersArchiveTableRowActions } from "./ArchiveCustomersRowActions";

export const archivedCustomersColumns: ColumnDef<CustomerWithContacts>[] = [
    ...customersColumns.slice(0, -1),
    {
        ...customersColumns[customersColumns.length - 1],
        cell: ({ table, row }) => <CustomersArchiveTableRowActions table={table} row={row} />,
    },
];